import EinstellungenSeitenKopf from './EinstellungenSeitenKopf';

export default EinstellungenSeitenKopf;
